import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/common';

const aboutFeatures = [
  {
    icon: 'ri-shield-star-line',
    title: '持照经营',
    description: '开元体育持有合法经营牌照，严格遵守行业规范，确保每一项业务都在合规框架内运行。我们与多家国际知名监管机构保持密切合作，为用户提供值得信赖的体育娱乐环境。',
  },
  {
    icon: 'ri-lock-star-line',
    title: '资金安全',
    description: '采用银行级别的加密技术和多重安全验证机制，保障用户的每一笔资金安全。所有用户资金均存放在独立的第三方监管账户中，与公司运营资金完全隔离。',
  },
  {
    icon: 'ri-scales-line',
    title: '公平公正',
    description: '坚持公平公正的经营原则，所有赛事赔率均基于权威数据源计算，确保每一场比赛的公正性。我们采用先进的随机算法和定期第三方审计，杜绝任何人为干预。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '社会责任',
    description: '积极履行企业社会责任，倡导理性娱乐理念。我们为所有用户提供自我限制工具和冷静期设置，帮助用户控制消费，预防过度娱乐。',
  },
];

const milestones = [
  { year: '2018', title: '开元体育正式成立', desc: '以专业体育娱乐平台为定位，开启创业之旅' },
  { year: '2019', title: '用户突破50万', desc: '凭借优质服务和丰富赛事资源，迅速积累用户口碑' },
  { year: '2020', title: '获得国际牌照', desc: '成功获得国际权威机构颁发的运营牌照' },
  { year: '2021', title: '全球化布局', desc: '业务拓展至全球200+国家和地区' },
  { year: '2022', title: '用户突破300万', desc: '成为行业领先的体育娱乐平台之一' },
  { year: '2023', title: '技术创新升级', desc: '推出AI智能赔率系统和多端同步平台' },
  { year: '2024', title: '电竞业务全面上线', desc: '覆盖全球顶级电竞赛事，成为电竞娱乐领域标杆' },
  { year: '2025', title: '用户突破500万', desc: '持续领跑行业，获得多项国际大奖' },
  { year: '2026', title: '开元体育全面升级', desc: '全新品牌形象，更优质的用户体验' },
];

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 开元体育"
        description="开元体育品牌介绍、发展历程、企业信誉与联系方式。了解开元体育的使命与价值观，专业体育娱乐平台为您提供安全、公平、流畅的体验。"
        keywords="开元体育,关于开元体育,开元体育品牌,开元体育信誉,开元体育联系方式"
        canonicalUrl="https://www.kaiyuansports.com/about"
        ogTitle="关于我们 - 开元体育"
        ogDescription="开元体育品牌介绍、发展历程、企业信誉与联系方式。了解开元体育的使命与价值观。"
      />

      <div className="pt-20 pb-14 md:pb-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', href: '/' },
                { name: '关于我们' },
              ]}
            />

            {/* Hero */}
            <div className="mt-8 text-center max-w-3xl mx-auto">
              <span className="text-primary-600 text-sm font-semibold tracking-wide">关于开元体育</span>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 mb-4">
                专业体育娱乐平台
              </h1>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                开元体育成立于2018年，是一家专注于在线体育娱乐的综合性平台。
                我们致力于通过先进技术和优质服务，为全球体育爱好者提供安全、公平、流畅的娱乐体验。
                经过多年发展，开元体育已服务超过500万用户，覆盖200多个国家和地区，
                成为行业领先的体育娱乐品牌。
              </p>
            </div>

            {/* Brand Image */}
            <div className="mt-10 relative rounded-lg overflow-hidden h-60 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20luxury%20sports%20lounge%20with%20warm%20golden%20atmosphere%20professional%20setting%20elegant%20interior%20design%20large%20screens%20displaying%20sports%20events%20comfortable%20seating%20premium%20feel%20cinematic%20lighting%20high%20detail&width=1400&height=600&seq=about-brand&orientation=landscape"
                alt="开元体育品牌形象"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            {/* Core Values */}
            <div className="mt-16">
              <div className="text-center mb-10">
                <span className="text-accent-600 text-sm font-semibold tracking-wide">核心价值观</span>
                <h2 className="font-heading text-3xl font-bold text-foreground-950 mt-2">
                  我们的承诺
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {aboutFeatures.map((feature) => (
                  <div
                    key={feature.title}
                    className="bg-background-50 border border-background-200 rounded-lg p-6 hover:border-primary-300 transition-all duration-200"
                  >
                    <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                      <i className={`${feature.icon} text-lg`}></i>
                    </div>
                    <h3 className="font-semibold text-foreground-900 text-sm mb-2">{feature.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Milestones */}
            <div className="mt-16">
              <div className="text-center mb-10">
                <span className="text-accent-600 text-sm font-semibold tracking-wide">发展历程</span>
                <h2 className="font-heading text-3xl font-bold text-foreground-950 mt-2">
                  品牌成长之路
                </h2>
              </div>

              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {milestones.map((item, index) => (
                    <div
                      key={item.year}
                      className={`relative flex items-start gap-6 ${
                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className="hidden md:block flex-1"></div>
                      <div className="relative z-10 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white flex-shrink-0">
                        <span className="w-2 h-2 rounded-full bg-white"></span>
                      </div>
                      <div className="flex-1 bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-all duration-200">
                        <span className="text-primary-600 font-heading text-lg font-bold">{item.year}</span>
                        <h3 className="font-semibold text-foreground-900 text-sm mt-1">{item.title}</h3>
                        <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Section */}
            <div className="mt-16">
              <div className="text-center mb-10">
                <span className="text-accent-600 text-sm font-semibold tracking-wide">联系我们</span>
                <h2 className="font-heading text-3xl font-bold text-foreground-950 mt-2">
                  与开元体育取得联系
                </h2>
                <p className="text-foreground-500 text-sm mt-2 max-w-md mx-auto">
                  我们7x24小时在线，随时为您提供专业服务
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Contact Info */}
                <div className="space-y-4">
                  <div className="bg-background-50 border border-background-200 rounded-lg p-5 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">电子邮件</h4>
                      <a href={`mailto:${siteConfig.contact.email}`} className="text-foreground-600 text-sm hover:text-primary-600 transition-colors cursor-pointer">
                        {siteConfig.contact.email}
                      </a>
                    </div>
                  </div>

                  <div className="bg-background-50 border border-background-200 rounded-lg p-5 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">客服热线</h4>
                      <a href={`tel:${siteConfig.contact.phone}`} className="text-foreground-600 text-sm hover:text-primary-600 transition-colors cursor-pointer">
                        {siteConfig.contact.phone}
                      </a>
                    </div>
                  </div>

                  <div className="bg-background-50 border border-background-200 rounded-lg p-5 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">公司地址</h4>
                      <p className="text-foreground-600 text-sm">{siteConfig.contact.address}</p>
                    </div>
                  </div>

                  <div className="bg-background-50 border border-background-200 rounded-lg p-5 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-wechat-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">微信公众号</h4>
                      <p className="text-foreground-600 text-sm">{siteConfig.contact.wechat}</p>
                    </div>
                  </div>
                </div>

                {/* Map */}
                <div className="relative rounded-lg overflow-hidden h-72 lg:h-full min-h-[300px] bg-background-100 border border-background-200">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3416.8554485494476!2d121.4997093151339!3d31.235534581460823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b27058d5bd40df%3A0x4c3b5e3e798861f4!2sLujiazui%2C%20Pudong%2C%20Shanghai!5e0!3m2!1sen!2scn!4v1691494400000!5m2!1sen!2scn"
                    className="w-full h-full"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="开元体育公司位置"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-16 text-center bg-background-100 rounded-lg p-8 md:p-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                准备好开始了吗？
              </h2>
              <p className="text-foreground-600 text-sm mb-6 max-w-md mx-auto">
                加入开元体育，体验专业体育娱乐服务。新用户注册即享专属礼包！
              </p>
              <Link
                to="/category/promotions"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即注册 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '开元体育是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '开元体育是一家专业的在线体育娱乐平台，提供足球、篮球、网球、电竞等50+体育项目的实时赔率和赛事资讯。',
                },
              },
              {
                '@type': 'Question',
                name: '开元体育是否合法？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，开元体育持有国际权威机构颁发的合法运营牌照，严格遵守行业规范，确保业务合规运行。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系开元体育客服？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过电子邮件 service@kaiyuansports.com 或拨打客服热线 400-888-6688 联系我们，7x24小时全天候在线服务。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}